export const QUICK_PROMPTS_USERS = ["Want to find IRR? I’m here to help! ?"];
export const QUICK_PROMPTS_ANSWERS = ["IRR is the rate of return where your investment breaks even."];

export const AGENT_OPTIONS = [
  { label: "Agent", icon: "assets/AIagentIcon.svg" },
  { label: "Ask", icon: "assets/AskIcon.svg" },
];

export const MODEL_OPTIONS = [
  { label: "Auto", icon: "assets/AutoIcon.svg", tone: "blue" },
  { label: "Claude", icon: "assets/GrokIcon.svg", tone: "orange" },
  { label: "ChatGpt", icon: "assets/ChatGptIcon.svg", tone: "green" },
  { label: "Gemini", icon: "assets/GeminiIcon.svg", tone: "yellow" },
  { label: "Grok", icon: "assets/GrokIcon.svg", tone: "purple" },
  { label: "DeepSeek", icon: "assets/DeepsheekIcon.svg", tone: "red" },
];
export const Data_history = [
  {
    id: 1,
    question: "What is IRR?",
    answer: "IRR is the rate of return where your investment breaks even.",
  },
  {
    id: 2,
    question: "How to calculate IRR?",
    answer: "To calculate IRR, you can use the formula: NPV = 0 = ∑ (Cash Flow / (1 + IRR)^t) - Initial Investment, where t is the time period.",
  },
  {
    id: 3,
    question: "What is the difference between IRR and ROI?",
    answer: "IRR (Internal Rate of Return) is a percentage that represents the annualized return of an investment, while ROI (Return on Investment) is a simple ratio that compares the gain or loss of an investment to its cost.",
  },
];
export type AgentOption = (typeof AGENT_OPTIONS)[number];
export type ModelOption = (typeof MODEL_OPTIONS)[number];